import { useTheme } from "next-themes";

type Coords = {
  x: number;
  y: number;
};

export function useThemeToggle() {
  const { theme, setTheme } = useTheme();

  const handleThemeToggle = (newMode: "light" | "dark" | "system") => {
    setTheme(newMode);
  };

  const toggleTheme = (
    newTheme: "light" | "dark" | "system",
    coords?: Coords,
  ) => {
    const root = document.documentElement;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (!document.startViewTransition || prefersReducedMotion) {
      handleThemeToggle(newTheme);
      return;
    }

    if (coords) {
      root.style.setProperty("--x", `${coords.x}px`);
      root.style.setProperty("--y", `${coords.y}px`);
    }

    document.startViewTransition(() => {
      handleThemeToggle(newTheme);
    });
  };

  return { theme, toggleTheme };
}
